import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { ImageuploadService } from 'src/app/services/imageupload.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
@Component({
  selector: 'app-training-users-detail',
  templateUrl: './training-users-detail.component.html',
  styleUrls: ['./training-users-detail.component.scss']
})
export class TrainingUsersDetailComponent {

  @Input() sessionAtt: any;
  @Output() updatedAttendees: EventEmitter<any> = new EventEmitter<any>();
  @Input() courseId: string = '';
  attendees: any[] = [];
  loadingUsers: boolean = false;
  attendeesId: any;
  fileProgress!: boolean;
  uploadProgress!: number;
  proof_url: any = [];
  staticURL = GlobalConstants.staticFilesURL;
  pipe: TranslatorPipe = new TranslatorPipe();

  attendanceOptions: any[] = [
    { label: this.translate('Present'), value: 'present' },
    { label: this.translate('Not Marked'), value: 'unknown' },
    { label: this.translate('Absent'), value: 'absent' },
  ]

  constructor(
    private dataService: DataService,
    private imageUploadService: ImageuploadService
  ) { }

  ngOnInit() {

    this.attendeesId = this.sessionAtt?.courseAttendees;
    if (this.sessionAtt?.attendanceProof?.proof_url) {
      this.proof_url = this.sessionAtt?.attendanceProof?.proof_url
    };

    this.getData();
  }

  translate(value: string) {
    return this.pipe.transform(value);
  }


  //check its image or Vids
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  //Getting Initial Data in bulk
  getData = async () => {
    this.loadingUsers = true;
    try {
      console.log('CURRENT S', this.sessionAtt)
      let query = {
        _id: { $in: this.sessionAtt?.courseAttendees }
      }
      let res = await this.dataService.postData('user/get', query);
      this.attendees = res?.data;

      this.attendees = this.attendees.map((item: any) => {
        const present = this.sessionAtt?.attendees?.length ? this.sessionAtt?.attendees.some((f: any) => f == item?._id) : false;
        const absent = this.sessionAtt?.absents?.length ? this.sessionAtt?.absents.some((f: any) => f == item?._id) : false;

        let status = '';
        if (present) {
          status = 'present';
        } else if (absent) {
          status = 'absent';
        } else {
          status = 'unknown'
        }

        return {
          ...item,
          present,
          absent,
          status
        };
      });

    } catch (error) {
      console.log(error);
    } finally {
      this.loadingUsers = false;
    }
  };

  change(id: string, status: string) {
    // Ensure arrays exist
    if (!this.sessionAtt.attendees) this.sessionAtt.attendees = [];
    if (!this.sessionAtt.absents) this.sessionAtt.absents = [];

    if (status == 'unknown') {
      // Remove id from both attendees and absents
      this.sessionAtt.attendees = this.sessionAtt.attendees.filter((attId: string) => attId !== id);
      this.sessionAtt.absents = this.sessionAtt.absents.filter((absId: string) => absId !== id);
    } else if (status == 'present') {
      // Add id to attendees if not already present
      if (!this.sessionAtt.attendees.includes(id)) {
        this.sessionAtt.attendees.push(id);
      }
      // Remove id from absents if exists
      this.sessionAtt.absents = this.sessionAtt.absents.filter((absId: string) => absId !== id);
    } else if (status == 'absent') {
      // Add id to absents if not already present
      if (!this.sessionAtt.absents.includes(id)) {
        this.sessionAtt.absents.push(id);
      }
      // Remove id from attendees if exists
      this.sessionAtt.attendees = this.sessionAtt.attendees.filter((attId: string) => attId !== id);
    }
  }

  async saveAttendees() {
    let sessionUpdated = {
      _id: this.sessionAtt._id,
      attendees: this.sessionAtt?.attendees || [],
      absents: this.sessionAtt?.absents || [],
      attendanceProof: { proof_url: this.proof_url }
    }
    try {
      let res = await this.dataService.postData('session/', sessionUpdated, 'PUT', false);
      if (res.error) {
        console.error('Error saving attendance:', res.msg);
        return;
      }
      else {
        // Emit the full session data so parent can update state
        this.updatedAttendees.emit({
          attendees: this.sessionAtt?.attendees || [],
          absents: this.sessionAtt?.absents || [],
          sessionId: this.sessionAtt._id
        });
      }
    } catch (e) {
      console.error('Exception saving attendance:', e);
    }
  }

  async addFiles(event: any) {

    const file: File = event.target.files[0];
    let obj: any = {};
    obj['file'] = {
      file: file,
      type: 'data'
    };
    console.log(obj);
    this.handleFileUpload(obj, 'file');
  }

  handleFileUpload(file: any, eventType: string): string | null {
    this.fileProgress = true;
    this.imageUploadService.uploadImageWithProgress(file.file.file, file.file.type).subscribe({
      next: (event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            this.uploadProgress = Math.round(event.loaded / event.total! * 100);
            console.log(`Uploaded! ${this.uploadProgress}%`);
            break;
          case HttpEventType.Response:
            if (event.ok) {
              setTimeout(() => {
                this.uploadProgress = 0;
              }, 1500);
              switch (eventType) {
                case 'file':
                  this.proof_url.push({ url: event.body.data });


                  break;
                //next case working..
              }
            } else {
              console.log("Error here")
            }
        }
      },
      error: (error) => {
        this.fileProgress = false;
        this.uploadProgress = 0;
        console.log("Error here");
      },
      complete: () => {
        this.fileProgress = false;
        this.uploadProgress = 0;
        console.log("Success here");
      }
    })
    return ""
  }

  removeProof(index: number) {
    if (this.proof_url && this.proof_url.length > index) {
      this.proof_url.splice(index, 1);
    }
  }

}
